module.exports = __webpack_public_path__ + "images/isuzueb3d3ddfbd66d597f47859580e433b4f.png";